import { Component, OnInit } from '@angular/core';
import { PortalService } from '../../../auth/portal.service';
import { DonutSlice } from '../../../interfaces/svgdonut.interface';

//import html2canvas from 'html2canvas';
import { jsPDF } from 'jspdf';
import 'svg2pdf.js';

import { LoginService } from '../../auth/login/login.service';
import { FarmerRemittanceService } from '../remittance.service';
import { DonutChartPipe } from '../../../svgdonut.pipe';
import { YesNoPipe } from '../../../yesno.pipe';
import { DeliveryPipe } from '../../../delivery.pipe';
import { DecimalPipe, PercentPipe, CurrencyPipe, DatePipe } from '@angular/common';

@Component({
    selector: 'app-clientremittancesized',
    templateUrl: './remittance.component.html',
    styleUrls: ['./remittance.component.scss'],
    imports: [DecimalPipe, PercentPipe, CurrencyPipe, DatePipe, DeliveryPipe, YesNoPipe, DonutChartPipe]
})
export class ClientRemittanceSizedComponent implements OnInit {
  d: Date = new Date();
  
  constructor(
  	public lS: LoginService,
  	public rS: FarmerRemittanceService,
  	public pS: PortalService
  	) { }

  ngOnInit() {
  }


}
